import ServerError from '@/model/ServerError'
import { constants } from '@/helpers/ErrorCodes'

export function handleError(authStore, toast, i18n, err, instance, info) {
    if (err instanceof ServerError) {
        if (err.status === 401) {
            toast.add({ severity: 'warn', summary: i18n.t('SESSION_EXPIRED'), detail: '', life: 5000 })
            authStore.logout()
        } else if (err.status === 500) {
            toast.add({ severity: 'error', summary: i18n.t('INTERNAL_SERVER_ERROR'), detail: '', life: 5000 })
        } else {
            if (err.errorCode === constants.VALIDATION_ERROR) {
                const summary = errorCodeToMessage(err.errorCode)
                const errors = err.detail.split(';');
                errors.forEach((value) => {
                    toast.add({ severity: 'error', summary: i18n.t(summary), detail: value, life: 5000 })
                })
            } else {
                let detail = i18n.t('UNKNOW_ERROR')
                if (err.errorCode !== null && err.errorCode !== undefined) {
                    let translatedErrorMessage = errorCodeToMessage(err.errorCode)
                    if (translatedErrorMessage !== 'UNKNOW_ERROR') {
                        detail = i18n.t(translatedErrorMessage)
                    }
                } else if (err.detail !== null && err.detail !== undefined) {
                    detail = err.detail
                }
                toast.add({ severity: 'error', summary: '', detail: detail, life: 5000 })
            }
        }
    } else {
        console.log(err)
        console.log(instance)
        console.log(info)
    }
    return false
}

function getConstantName(value) {
    return Object.keys(constants).find(key => constants[key] === value);
}

function errorCodeToMessage(errorCode) {
    const constantName = getConstantName(errorCode);
    return constantName ? constantName : 'UNKNOW_ERROR';
}